import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from '@components/common';
import './NonAuthLayout.css';

const NonAuthLayout = ({ children }) => {
  return (
    <div className="non-auth-layout">
      <header className="non-auth-layout__header">
        <div className="container">
          <div className="non-auth-layout__header-content">
            <Link to="/" className="non-auth-layout__logo">
              Bizz.plus
            </Link>
            <nav className="non-auth-layout__nav">
              <Link to="/" className="non-auth-layout__nav-link">
                Home
              </Link>
              <Link to="/about" className="non-auth-layout__nav-link">
                About
              </Link>
              <Link to="/contact" className="non-auth-layout__nav-link">
                Contact
              </Link>
              <Link to="/login">
                <Button variant="primary" size="sm">
                  Login
                </Button>
              </Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="non-auth-layout__main">
        <div className="non-auth-layout__content">{children}</div>
      </main>

      <footer className="non-auth-layout__footer">
        <div className="container">
          <div className="non-auth-layout__footer-content">
            <p className="non-auth-layout__footer-text">
              &copy; {new Date().getFullYear()} Bizz.plus. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

NonAuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NonAuthLayout;
